module.exports = __webpack_public_path__ + "static/img/role-es.64a7ec1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/role-4/role-es.png
// module id = eK1d
// module chunks = 1